import { render, staticRenderFns } from "./PaymentOrdersCap.vue?vue&type=template&id=4ef67806&"
import script from "./PaymentOrdersCap.vue?vue&type=script&lang=js&"
export * from "./PaymentOrdersCap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports